export default __webpack_public_path__ + "static/media/duplicate_green_icon.b8fdb775.svg";